// extracted by mini-css-extract-plugin
module.exports = {"container":"aboutUs_container__3-V_Y","labelYe":"aboutUs_labelYe__1ag2O","active":"aboutUs_active__2rO35"};